module.exports = __webpack_public_path__ + "img/1158.248fdd68.jpg";